import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * ScrollToTop component that scrolls the window to the top when the route changes
 * This solves the issue of navigating to a new page and being positioned partway down
 */
const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // A #fragment names a place on the page (/learn/glossary#push); the page
    // scrolls itself there (hooks/useScrollToHash), so don't undo it.
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop; 